import { RouteLocationNormalized, NavigationGuardNext } from 'vue-router';
import { useKnowledgeStore } from '@getmayday/vue-modules';

export default async (
  to: RouteLocationNormalized,
  from: RouteLocationNormalized,
  next: NavigationGuardNext,
) => {
  if (to.name !== 'index' || to.query.silent) return next();
  const knowledgeStore = useKnowledgeStore();
  const configStore = useConfigStore();
  const { knowledgeId } = storeToRefs(knowledgeStore);
  const { lastEntityRoute } = storeToRefs(configStore);
  let force = to.query.force || '0';
  // In case of a focus tab and the current route is not home/knowledge
  if (
    to.query.focusTab === '1' &&
    from.meta.tabIndex &&
    from.meta.tabIndex > 0
  ) {
    return next();
  }

  // In case we have a last path knowledge navigation
  if (lastEntityRoute.value?.path && force === '0') {
    const { query } = lastEntityRoute.value;
    return next({
      ...lastEntityRoute.value,
      query: { ...query, noSave: '1' },
    });
  }

  // If there is no focus knowledge
  if (!knowledgeId.value) {
    try {
      force = '1';
      knowledgeId.value = await configStore.initKnowledge();

      if (!knowledgeId.value) throw 'MISSING FOCUS KNOWLEDGE';
    } catch {
      // logout
      configStore.logout();
      return next();
    }
  }

  next({
    path: `/knowledges/${knowledgeId.value}`,
    query: {
      ...to.query,
      force,
    },
  });
};
